import { Pause, Play, SkipBack, SkipForward } from "@mynaui/icons-react";

type AudioControlsProps = {
  isPlaying: boolean;
  onPlayPauseClick: (shouldPlay: boolean) => void;
  onPrevClick: () => void;
  onNextClick: () => void;
};

const AudioControls = ({
  isPlaying,
  onPlayPauseClick,
  onPrevClick,
  onNextClick,
}: AudioControlsProps) => (
  <div className="flex items-center justify-center gap-2">
    <button
      type="button"
      className="prev"
      aria-label="Previous"
      onClick={onPrevClick}
    >
      <SkipBack className="w-5 h-5"/>
    </button>
    {isPlaying ? (
      <button
        type="button"
        className="pause"
        onClick={() => onPlayPauseClick(false)}
        aria-label="Pause"
      >
        <Pause className="w-6 h-6"/>
      </button>
    ) : (
      <button
        type="button"
        className="play"
        onClick={() => onPlayPauseClick(true)}
        aria-label="Play"
      >
        <Play className="w-6 h-6"/>
      </button>
    )}
    <button
      type="button"
      className="next"
      aria-label="Next"
      onClick={onNextClick}
    >
      <SkipForward className="w-5 h-5"/>
    </button>
  </div>
);

export default AudioControls;
